import { RemoteGetAllStudentsNotPaginated } from 'data/usecases';
import { GetAllStudentsNotPaginatedUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudents } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllStudentsNotPaginated =
  (): GetAllStudentsNotPaginatedUseCaseInterface =>
    new RemoteGetAllStudentsNotPaginated(
      makeApiUrlStudents(),
      makeAxiosHttpClient(),
    );
